/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import ArrowIcon from '../../../assets/arrowIcon.png'
import ArrowUpIcon from '../../../assets/arrowUpIcon.png'
import IconDots from '../../../assets/dots.png'
import { RangeCriteriaDetail } from 'components/atoms/RangeCriteriaDetail/RangeCriteriaDetail'
import { MultiSelectCriteriaDetail } from 'components/atoms/MultiSelectCriteriaDetail/MultiSelectCriteriaDetail'
import { GeolocationCriteriaDetail } from 'components/atoms/GeolocationCriteriaDetail/GeolocationCriteriaDetail'
import { InputFileDetail } from 'components/atoms/InputFileDetail/InputFileDetail'
import { SwitchCriteriaDetail } from 'components/atoms/SwitchCriteriaDetail/SwitchCriteriaDetail'
import { MeasurementCriteriaDetail } from 'components/atoms/MeasurementCriteriaDetail/MeasurementCriteriaDetail'

interface Props {
    rules: {
        chutes: number[]
        name: string
        criterias: any[]
    }[]
}

const RuleKeys = {
    weight: 'weight',
    declared_value: 'declared_value',
    postal_code_range: 'postal_code_range',
    distribution_provider: 'distribution_provider',
    service_code: 'service_code',
    service_types: 'service_types',
    clients: 'clients',
    states: 'states',
    town: 'town',
    township: 'township',
    postal_code_list: 'postal_code_list',
    ddu_ddp: 'ddu_ddp',
    measurements: 'measurements',
}
const SORT_PRIORITY = {
    [RuleKeys.postal_code_range]: 1,
    [RuleKeys.states]: 2,
    [RuleKeys.town]: 3,
    [RuleKeys.township]: 4,
}

export const AccordionPattern = ({ rules }: Props) => {
    const [expandedItems, setExpandedItems] = useState<string[]>([])
    const sortCriteria = (criterias: any[]) => {
        return [...criterias].sort((a, b) => {
            const priorityA = SORT_PRIORITY[a.key] || 0
            const priorityB = SORT_PRIORITY[b.key] || 0
            return priorityA - priorityB
        })
    }

    const renderCriteria = (rule: any) => {
        switch (rule.key) {
            case RuleKeys.weight:
            case RuleKeys.declared_value:
            case RuleKeys.postal_code_range:
                return (
                    <RangeCriteriaDetail
                        id={rule.id}
                        name={rule.name}
                        valueKey={rule.key}
                        criteria_configurations={rule.criteria_configurations}
                    />
                )
            case RuleKeys.distribution_provider:
            case RuleKeys.service_code:
            case RuleKeys.service_types:
            case RuleKeys.clients:
                return (
                    <MultiSelectCriteriaDetail
                        id={rule.id}
                        name={rule.name}
                        valueKey={rule.key}
                        criteria_list={rule.criterial_list}
                    />
                )
            case RuleKeys.township:
            case RuleKeys.town:
            case RuleKeys.states:
                return (
                    <GeolocationCriteriaDetail
                        id={rule.id}
                        name={rule.name}
                        valueKey={rule.key}
                        criteria_list={rule.criterial_list}
                    />
                )
            case RuleKeys.postal_code_list:
                return (
                    <InputFileDetail
                        id={rule.id}
                        name={rule.name}
                        valueKey={rule.key}
                        criteria_quantity={rule.criteria_quantity}
                    />
                )
            case RuleKeys.ddu_ddp:
                return (
                    <SwitchCriteriaDetail
                        id={rule.id}
                        name={rule.name}
                        criteria_configurations={rule.criteria_configurations}
                        key={rule.key}
                    />
                )
            case RuleKeys.measurements:
                return (
                    <MeasurementCriteriaDetail
                        id={rule.id}
                        name={rule.name}
                        key={rule.valueKey}
                        criteria_list={rule.criterial_list}
                    />
                )
            default:
                return null
        }
    }

    return (
        <Accordion
            className="bg-white w-full border-b border-b-[#CBD5E1]"
            allowZeroExpanded
            onChange={(e: string[]) => setExpandedItems(e)}
        >
            {rules.map((item, index) => (
                <AccordionItem uuid={index.toString()}>
                    <AccordionItemHeading>
                        <AccordionItemButton className="pt-3 pr-4 pb-3 pl-3">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center">
                                    <span className="accordion-arrow ml-3 mr-4 transition-transform duration-300 [.accordion__button[aria-expanded='false']>&]:rotate-180">
                                        {expandedItems.includes('0') ? (
                                            <img
                                                src={ArrowUpIcon}
                                                alt="ArrowUpIcon"
                                            />
                                        ) : (
                                            <img
                                                src={ArrowIcon}
                                                alt="ArrowIcon"
                                            />
                                        )}
                                    </span>
                                    <h2 className="text-base font-normal text-[#141A1F]">
                                        {item.name}
                                    </h2>
                                    <img
                                        className="ml-5"
                                        src={IconDots}
                                        alt="IconDots"
                                    />
                                </div>
                                <p className="text-base font-normal text-[#3E5060] flex items-center"></p>
                            </div>
                        </AccordionItemButton>
                    </AccordionItemHeading>

                    <AccordionItemPanel className="mx-3">
                        <div className="flex">
                            <div className="space-y-[10px] mx-[44px] w-2/3 mb-5">
                                {sortCriteria(item.criterias).map((rule) => {
                                    return renderCriteria(rule)
                                })}
                            </div>
                            <div className="flex gap-2 mb-5 flex-wrap w-1/3 justify-end">
                                {item.chutes.map((index) => (
                                    <div
                                        key={index}
                                        className="w-[32px] h-[32px]  flex justify-center items-center rounded-full"
                                    ></div>
                                ))}
                            </div>
                        </div>
                    </AccordionItemPanel>
                </AccordionItem>
            ))}
        </Accordion>
    )
}
